// imports react
import React, { useEffect, useState } from "react";

//imports libraries
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";

//imports components
import styles from "../styles/questionary.module.css";
import { LogoutButton } from "../components/LogoutButton.js";
import { Questions } from "../components/Questions";

import { urlAPI_Current } from "../config.js";
import { logoutUser } from "../logoutUser";
import { userLogged } from "../userLogged.js";
import { verifyUserPaid } from "../verifyUserPaid.js";
import { Menu } from "../components/Menu.js";
import Swal from "sweetalert2";
import useAccessTracking from "../components/useAccessTracking.js";
import { verifyAuthToken } from "../verifyAuthToken.js";

export function Questionary() {
  const [userData, setUserData] = useState([]);
  const [questions, setQuestions] = useState();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const navigateTo = useNavigate();
  const userName = localStorage.getItem("name");

  const [darkMode, setDarkMode] = useState(() => 
    window.localStorage.getItem('darkMode') === 'true'
  );

  useAccessTracking();

  async function getQuestionsAnsweredCount(){
    const response = await axios.post(
      `${urlAPI_Current}/getQuestionsAnsweredCount`,
      {}, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
        }
    }
    );
    if(response.data.countQuestionsAnswered == 0){
      //navigateTo("/questionaryAlert");
      // return;
    } else if (response.data.countQuestionsAnswered >= 1 && response.data.countQuestionsAnswered < 12){
      //navigateTo("/questionary");
      // return;
    } else if (response.data.countQuestionsAnswered >= 12){
      navigateTo("/resultQuestionary");
      return;
    }
  }


  async function getUserLogged(){
    const user = await userLogged();
    setUserData(user)

    if (!user) { // não tiver usuário, ou authToken invalido
      toast.error('Faça o login primeiro');
      navigateTo('/login');
    } 
    else if(user.codTipoUsuario != 1){
      logoutUser();
      toast.error('Você não tem acesso a essa página');
      navigateTo('/login');
    } else { // loga
        const responsePaid = await verifyUserPaid();
        if(responsePaid.success == true){
          console.log(`Plano Atual ${responsePaid.plan}`);
          await getQuestionsAnsweredCount();
          getAllQuestions();
          getQuestionsAnswered();
        } else {
          toast.error('Faça o pagamento primeiro');
          navigateTo("/plans");
        }
    }
  }

  async function getAllQuestions() {
    try {
      const response = await axios.post(
        `${urlAPI_Current}/getAllQuestions`,
        {}, {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
      }
      );
      if (response.data.success == true) {
        const responseQuestions = response.data.questions;
        if (responseQuestions) {
          setQuestions(responseQuestions);
          console.log(responseQuestions);
        }
      } else {
        console.log("Não possui questões");
      }
    } catch (error) {
      console.log("Erro ao buscar questões");
    }
  }

  async function getQuestionsAnswered() {
    try {
      const response = await axios.post(
        `${urlAPI_Current}/getQuestionsAnswered`, {} , {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('authToken')}`  
          }
       }
      );
      if (response.data.success == true) {
        const responseQuestions = response.data.lastAnswered;
        if (responseQuestions) {
          setCurrentQuestionIndex(responseQuestions);
        }
      } else {
        console.log("Não respondeu");
      }
    } catch (error) {
      console.log("Erro ao buscar respondidas");
    }
  }

  const handleAdvance = () => {
    setCurrentQuestionIndex(currentQuestionIndex + 1);
  };

  const handleReturn = () => {
    setCurrentQuestionIndex(currentQuestionIndex - 1);
  };

  async function navigateToResults(){
    navigateTo("/resultQuestionary")
  }

  useEffect(() => {
    getUserLogged();
    
    window.localStorage.setItem('darkMode', darkMode);
    document.documentElement.setAttribute('data-theme', darkMode ? 'dark' : 'light');
  }, [darkMode]);

  useEffect(() => {
    verifyAuthToken(navigateTo);
  }, []);

  return (
    <div className={styles.divQuestionary}>
      <Menu darkMode={darkMode} />

      <div className={styles.containerQuestionary}>
        {questions?.length > 0 && (
          <div className={styles.containerTitles}>
            {questions.map((question, index) => (
              <div
                key={question.codPergunta}
                className={styles.containerTitlesQuestions}
              >
                {index < currentQuestionIndex ? (
                  <div className={styles.questionsAnswered}>
                    <strong>{question.titulo}</strong>
                  </div>
                ) : index === currentQuestionIndex ? (
                  <div className={styles.questionsActually}>
                    <strong>{question.titulo}</strong>
                  </div>
                ) : (
                  <div className={styles.questionsAnswered}>
                    <span>{question.titulo}</span>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
        {questions ? (
          questions?.length > 0 && currentQuestionIndex < questions?.length ? (
            <Questions
              idQuestion={questions[currentQuestionIndex].codPergunta}
              subtitle={questions[currentQuestionIndex].subtitulo}
              opcaoA={questions[currentQuestionIndex].opcaoA}
              opcaoB={questions[currentQuestionIndex].opcaoB}
              opcaoC={questions[currentQuestionIndex].opcaoC}
              opcaoD={questions[currentQuestionIndex].opcaoD}
              onAdvance={handleAdvance}
              onReturn={handleReturn}
            />
          ) : (
            <div className={styles.divConcluded}>
              <h3>Questionário Respondido com sucesso!</h3>
              <p>Confira seus resultados na próxima página</p>

              <button onClick={navigateToResults}>Ver resultados</button>
            </div>
          )
        ) : <p className={styles.divConcluded}>Buscando questões...</p>}
        
      </div>
    </div>
  );
}
